import React, {useEffect, useState} from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { getData } from '../../../helpers/indexedDbHelper';
import { useRefresh } from '../../../hooks/useRefresh';
import ListProducts from '../../../screens/menu/ListProducts';
import HappyHourScreen from '../../../screens/menu/happyHour';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
import { useSelector } from 'react-redux';

const Index = ({ showBack = true, showImageTop = false, children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {
   
    const [showModal, setShowModal] = useState(false);
  const [menus, setMenus] = useState([]);
  const { change } = useRefresh();
  const [dataDrinks, setDataDrinks] = useState(false);
  const [dataEntress, setdataEntress] = useState(false);
  const [dishs, setdishs] = useState(false);
       const [showListProduct2, setShowListProduct2] = useState(false);
      const [showHappy, setShowHappy] = useState(false);
    const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");
  
 const [showBoost, setshowBoost] = React.useState(false);

  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
   const {
      goHomeInit
   } = useSelector((state) => state.initLoad);
  
  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
  };
  
   useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
             
              setMenus(data);
          });
      }, [change]);
      
     useEffect(() => {
              menus.map((item) => {
                  if (item.id === 491) {
                    setDataDrinks(item);
                  }
                  if (item.id === 482) {
                    setdataEntress(item);
                  }
                 
              });
     }, [menus]);
  
  
  
       useEffect(() => {
              console.log(goHomeInit, 'q mas qlq')
                setShowListProduct2(false);
              setShowHappy(false)
              
       }, [goHomeInit]);
      

  
    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
       
      }}>

        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

            <div className='nav-menu-bar' style={{
             
              width: '100%',
              position: 'relative'
            
            }}>
               
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'center',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',}}>
                     {showBack && (
                        <div
                            onClick={()=>handleButtonClick()}
                                style={{
                                  width: 140,
                                  height: 52,
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                  justifyContent: "center",
                                  cursor: 'pointer',
                                  marginLeft: 35,
                                  zIndex: 999,
                                  position: 'relative',
                                  background: "#C70100",
                                  borderRadius: 10
                            }}>
                           
                              <p style={{position:'absolute', color: 'white', fontSize: 20, fontWeight: '900'}}>GO BACK</p>
                          </div>
                    )}

                  </div>
                  
                  {showFooter && <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        <div onClick={()=>setShowModal('#')} target='_blank'> <img
                        style={{
                          width: 20,
                            height: 20,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div>

                      <div target='_blank' onClick={()=>setShowModal('#')}> 
                        <img
                          style={{
                              width: 20,
                                height: 20,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div>

                      {/* <div target='_blank' onClick={()=>setShowModal('https://stanciaperuvianfusion.com/?fbclid=PAZXh0bgNhZW0CMTEAAabcJIytXY618p9SWTbgSUCDqZjeqqwDe6N-mVtvD2e3OsRHHxJ4b-C03sg_aem_ySjBYnYb0DeoIbZGrDsMbQ')}> 
                        <img
                          style={{
                              width: 30,
                                height: 30,
                                marginInline: 10
                        }}
                          src={require('./assets/web.png')}
                          alt="Logo"
                        /> 
                      </div>
                             */}
                  
                    <div>
                    
                    </div>
                      </div>
                  </div>} 
                  

                 
              </div>
              }
              


            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
            bottom: 0,
                  alignSelf: 'center',
                  width: '100%',
                  left: 0, 

            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
                    width: '100%',
                
              }}>
              <div

                    onClick={() => {
                      setdishs(dataEntress)
                     setShowListProduct2(true)
                  }}
                style={{
                  width: 190,
                  borderRadius: 9,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'row',
                     paddingInline: 15,
                    boxSizing: 'border-box'
                  }}>
                     <img src={require('./assets/food.png')} style={{width: '100%', height: 100, objectFit: 'contain'}}  />
                  </div>
                   <div
                    onClick={() => {
                      setShowHappy(true)
                  }}
                style={{
                 width: 190,
                  borderRadius: 9,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'row',
                     paddingInline: 15,
                    boxSizing: 'border-box'
                  }}>
                
                    <img src={require('./assets/drinks.png')} style={{width: '100%', height: 100, objectFit: 'contain'}}  />
               
                 
              </div>

              <div
                    onClick={() => {
                      handleButtonClick()
                          store.dispatch(setGoHome(!goHomeInit));
                      console.log({goHome})
                      if (goHome) {
                        goHome()
                      }
                }}
                style={{
                  width: 190,
                  borderRadius: 9,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'row',
                     paddingInline: 15,
                    boxSizing: 'border-box'
                  }}>
                      <img src={require('./assets/homes.png')} style={{width: '100%', height: 100, objectFit: 'contain'}}  />
              </div>
            </div>
            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                    alignItems: 'center',
                  marginTop: -20
              
              }}>
                  <div
                     onClick={()=> setshowBoost(true)}
                style={{flexDirection: 'row', alignItems: 'center', width: '80%', margin: '0 auto'}}>
                
                     <p
                  style={{
                      color: '#000',
                      fontWeight: '900',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com V1.2
                </p>
              </div>
            </div>
          </div>
          }
            

              {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }
            

             {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

               <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            
            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>

          {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}

        {showListProduct2 && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct2}
            />}
      </div>
     
    );
  };

export default Index;